import { Button } from "../ui/button";
import type { LeaveReviewLink } from "./leave-review-links";
import type { ReactElement } from "react";
import { cn } from "../../lib/utils";

interface LeaveReviewButtonsProps {
  align: "center" | "start";
  className?: string;
  links: LeaveReviewLink[];
}

const LeaveReviewButtons = ({ align, className, links }: LeaveReviewButtonsProps): ReactElement => (
  <div
    className={cn(
      "jobsite:flex jobsite:flex-wrap jobsite:gap-3",
      align === "center" ? "jobsite:justify-center" : "jobsite:justify-start",
      className,
    )}
  >
    {links.map((link, index) => (
      // One primary action: the first link is filled, the rest are outlined.
      <Button key={link.key} asChild className="jobsite:h-11" size="lg" variant={index === 0 ? "default" : "outline"}>
        <a data-testid={`reviews-leave-${link.key}`} href={link.href} rel="noopener noreferrer" target="_blank">
          {link.label}
        </a>
      </Button>
    ))}
  </div>
);

export { LeaveReviewButtons };
